"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AtImportController", {
    enumerable: true,
    get: function() {
        return AtImportController;
    }
});
const _common = require("@nestjs/common");
const _express = require("express");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _Jobs = require("~/interface/Jobs");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let AtImportController = class AtImportController {
    async triggerSync(context, req) {
        const jobs = await this.jobsService.jobList();
        const fnd = jobs.find((j)=>j.data.syncId === req.params.syncId);
        if (fnd) {
            _catchError.NcError.badRequest('Sync already in progress');
        }
        const syncSource = await _models.SyncSource.get(context, req.params.syncId);
        const user = await syncSource.getUser();
        // Treat default baseUrl as siteUrl from req object
        let baseURL = req.ncSiteUrl;
        // if environment value avail use it
        // or if it's docker construct using `PORT`
        if (process.env.NC_DOCKER) {
            baseURL = `http://localhost:${process.env.PORT || 8080}`;
        }
        const job = await this.jobsService.add(_Jobs.JobTypes.AtImport, _extends({
            context,
            syncId: req.params.syncId
        }, (syncSource == null ? void 0 : syncSource.details) || {}, {
            baseId: syncSource.base_id,
            sourceId: syncSource.source_id,
            authToken: '',
            baseURL,
            user: user
        }));
        return {
            id: job.id
        };
    }
    async abortImport() {
        return {};
    }
    constructor(jobsService){
        this.jobsService = jobsService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/syncs/:syncId/trigger',
        '/api/v2/meta/syncs/:syncId/trigger'
    ]),
    (0, _extractidsmiddleware.Acl)('airtableImport'),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _express.Request === "undefined" ? Object : _express.Request
    ]),
    _ts_metadata("design:returntype", Promise)
], AtImportController.prototype, "triggerSync", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/syncs/:syncId/abort',
        '/api/v2/meta/syncs/:syncId/abort'
    ]),
    (0, _extractidsmiddleware.Acl)('airtableImport'),
    (0, _common.HttpCode)(200),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], AtImportController.prototype, "abortImport", null);
AtImportController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService
    ])
], AtImportController);
